import React from 'react';
import styled from '@emotion/styled';

const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  ${props => props.height && `
    height: ${props.height};
  `}
  background: #25253C;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  
  /* Custom scrollbar for webkit browsers */
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(244, 63, 96, 0.5);
    border-radius: 4px;
    
    &:hover {
      background: rgba(244, 63, 96, 0.7);
    }
  }
  
  @media (max-width: 768px) {
    border-radius: 8px;
    margin: 0;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    margin: 0;
    width: 100%;
    border-radius: 6px;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 900px;
  background: #25253C;
  
  @media (max-width: 1200px) {
    min-width: 800px;
  }
  
  @media (max-width: 768px) {
    min-width: 700px;
  }
  
  @media (max-width: 480px) {
    min-width: 600px;
  }
`;

const TableHead = styled.thead`
   background: #25253C;
  position: sticky;
  top: 0;
  z-index: 2;
`;

const TableHeaderCell = styled.th`
  padding: 18px 12px 18px 12px;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.50);
  vertical-align: middle;
  background: #25253C;
  text-align: left;
  white-space: nowrap;
  
  @media (max-width: 1200px) {
    padding: 16px 10px;
    font-size: 0.95rem;
  }
  
  @media (max-width: 768px) {
    padding: 14px 8px;
    font-size: 0.875rem;
  }
  
  @media (max-width: 480px) {
    padding: 12px 6px;
    font-size: 0.8rem;
  }
`;

const TableBody = styled.tbody`
  background: #1E1E35;
`;

const TableRow = styled.tr`
  border-radius: 12px;
  background: #1E1E35;
  cursor: ${props => props.cursor || 'default'};
  transition: all 0.2s ease;
  
  &:nth-of-type(even) {
    background: #25253C;
  }
  
  &:hover {
     background: #313151;
  }
  
  @media (max-width: 768px) {
    &:hover {
      transform: none;
    }
  }
`;

const TableCell = styled.td`
  padding: 18px 12px;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1rem;
  color: #fff;
  vertical-align: middle;
  white-space: nowrap;
  
  @media (max-width: 1200px) {
    padding: 16px 10px;
    font-size: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 14px 8px;
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 6px;
    font-size: 16px;
  }
`;

/**
 * columns: Array<{ key, label, render?: (item, idx) => ReactNode }>
 * data: Array<object>
 */
const Table = ({ columns, data, height }) => (
  <TableWrapper height={height}>
        <StyledTable>
            <TableHead>
                <tr>
                    {columns.map(col => (
                        <TableHeaderCell key={col.key}>{col.label}</TableHeaderCell>
                    ))}
                </tr>
            </TableHead>
            <TableBody>
                {data.map((item, idx) => (
          <TableRow
            key={item._id || idx}
            onClick={item._rowProps?.onClick}
            cursor={item._rowProps?.style?.cursor}
            hoverColor={item._rowProps?.onClick ? 'rgba(244, 63, 96, 0.1)' : 'inherit'}
          >
                        {columns.map(col => (
                            <TableCell key={col.key}>
                                {col.render ? col.render(item, idx) : item[col.key]}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </StyledTable>
    </TableWrapper>
);

export { Table, TableWrapper, StyledTable, TableHead, TableHeaderCell, TableBody, TableRow, TableCell }; 